import React from "react";
import { Heading, Text } from "ui-components";

export interface IOrganizationCardStatsProps {
  title: string;
  stats: string | number;
  sizeClass?: string;
}

export function OrganizationCardStats({
  title,
  stats,
  sizeClass = "flex-1",
}: IOrganizationCardStatsProps): JSX.Element {
  return (
    <div className={`flex ${sizeClass} flex-col`}>
      <Heading intent="themePrimary" variant="h3">
        {stats || 0}
      </Heading>
      <Text>{title}</Text>
    </div>
  );
}
